export default function getPaginationWidth(pageCount: number): string {
  switch (true) {
    case pageCount >= 10000:
      return 'w-12 sm:w-16'

    case pageCount >= 1000:
      return 'w-10 sm:w-14'

    case pageCount >= 100:
      return 'w-8 sm:w-12'

    default:
      return 'w-6 sm:w-10'
  }
}
